import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../components/button";
import { refund as refundEndpoint } from "../../api/endpoint";
import { useSelector } from "react-redux";
import Loader from "../../components/loader";
import axios from "axios";
import toast from "react-hot-toast";

const RefundModal = ({
  isRefundOpen,
  closeRefundModal,
  selectedTransaction,
  fetchTransactions,
}) => {
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  const refund = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        refundEndpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${auth}`,
          },
          params: {
            paymentIntentId: selectedTransaction?.transactionId,
          },
        }
      );
      toast.success("Refund Successful")
      closeRefundModal()
      fetchTransactions()
    } catch (error) {
      console.error("Error refunding", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <Modal show={isRefundOpen} onHide={closeRefundModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Initiate Refund</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want refund?</Modal.Body>
        <Modal.Footer>
          <Button text="Refund" callBack={refund} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RefundModal;
